// extracted by mini-css-extract-plugin
export var growableInput = "_6s-0";
export var tagContainer = "_6s-2";
export var textInput = "_6s-1";